<template>
  <div
    class="mk-body-item"
    :class="{ showMore: showMore, isMore: unscrambles.showMore }"
  >
    <div v-html="unscrambles.text"></div>
    <div
      class="more-btn2"
      v-if="unscrambles.onShowMore"
      @click="unscrambles.onShowMore()"
    >
      <template v-if="!showMore">
        <span>更多</span>
        <Icon type="ios-arrow-down" />
      </template>
      <template v-else>
        <span>收起</span>
        <Icon type="ios-arrow-up" />
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    unscrambles: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showMore: false,
    };
  },
  watch: {
    unscrambles: {
      handler(newValue, oldValue) {
        this.init();
      },
      deep: true,
    },
  },
  methods: {
    init() {
      if (this.unscrambles.isShowMore) {
        this.showMore = this.unscrambles.isShowMore.value;
      }
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
</style>